import React, { PropsWithChildren, useId } from 'react'

import { gt } from '~/lib/gt'

import styles from './FormInput.module.css'

type Props = {
  className?: string
  errorMessage?: string
  label?: string
  reserveErrorSpace?: boolean
} & React.InputHTMLAttributes<HTMLInputElement>

export const FormInput = React.forwardRef<HTMLInputElement, PropsWithChildren<Props>>(
  ({ className, label, errorMessage, reserveErrorSpace, ...rest }, ref) => {
    const errorId = useId()
    const combinedClassName = `${styles.input} ${className ?? ''} ${errorMessage && styles.inputError}`

    return (
      <div className={styles.inputWrapper}>
        {label && <div className={styles.label}>{label}</div>}
        <input
          ref={ref}
          className={combinedClassName}
          aria-invalid={!!errorMessage}
          aria-describedby={errorMessage || reserveErrorSpace ? errorId : undefined}
          {...rest}
        />
        {(errorMessage || reserveErrorSpace) && (
          <p className={styles.error} id={errorId} role='alert'>
            {errorMessage ? gt.tp('Error', errorMessage) : '\u00A0'}
          </p>
        )}
      </div>
    )
  }
)
